var _path, _circle, _circle2, _circle3, _circle4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgChristmasRefferal = function SvgChristmasRefferal(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 228,
    viewBox: "0 0 320 228",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m275.241 46.14-23.234-23.158a1.396 1.396 0 0 1-.422-1.052c.005-.37.157-.724.422-.983a1.41 1.41 0 0 1 1.971 0 9.326 9.326 0 0 0 6.583 2.718c2.47 0 4.837-.978 6.583-2.718a9.264 9.264 0 0 0 2.727-6.561 9.263 9.263 0 0 0-2.727-6.561 19.699 19.699 0 0 0-4.154-3.158A19.756 19.756 0 0 0 252.992 2a20.1 20.1 0 0 0-14.137 5.88A19.96 19.96 0 0 0 233 21.99a19.965 19.965 0 0 0 5.84 14.115l27.318 27.158A9.096 9.096 0 0 0 272.706 66a9.376 9.376 0 0 0 6.618-2.737A9.107 9.107 0 0 0 282 56.737a9.244 9.244 0 0 0-2.676-6.596l-4.083-4.001zm-18.658 1.684 7.182-7.158 6.97 6.948-7.181 7.158-6.971-6.948zm-9.927-9.895 7.181-7.158 6.971 6.948-7.182 7.158-6.97-6.948zm19.01-23.508A5.251 5.251 0 0 1 264.187 18a5.222 5.222 0 0 1-6.618.491l5.069-8.982 1.549 1.333a5.044 5.044 0 0 1 1.479 3.579zm-6.688-7.018-5.07 8.983h-1.549l-5.491-8.912a15.183 15.183 0 0 1 6.125-1.264 15.465 15.465 0 0 1 5.985 1.193zm-17.18 3.439 1.408-1.263 5.422 8.772c-.284.405-.542.827-.775 1.263l-10.561 3.649a15.481 15.481 0 0 1 4.506-12.421zm-3.591 16.561 9.576-3.298c.29.673.695 1.29 1.197 1.825l1.901 1.824-7.182 7.158-1.901-1.824a15.842 15.842 0 0 1-3.591-5.685zm38.09 32.912a4.867 4.867 0 0 1-3.59 1.474 5.009 5.009 0 0 1-3.591-1.474l-2.535-2.526 7.182-7.158 2.534 2.526a4.832 4.832 0 0 1 1.479 3.58 4.973 4.973 0 0 1-1.479 3.578z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 153,
    cy: 106,
    r: 4,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 105,
    cy: 18,
    r: 4,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 258,
    cy: 168,
    r: 2,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 19,
    cy: 168,
    r: 2,
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChristmasRefferal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/christmas_refferal.d4784582.svg";
export { ForwardRef as ReactComponent };